module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "top-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.props.acf.logo
    }
  })])], 1), _c('div', {
    staticClass: "header-right"
  }, [_c('ul', {
    staticClass: "social-icon"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": _vm.props.acf.facebook_url,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shift",
    attrs: {
      "src": "https://www.coastal-orthodontics.com/wp-content/uploads/2019/03/facebook.png",
      "alt": "Facebook"
    }
  })])]), _c('li', [_c('a', {
    attrs: {
      "href": _vm.props.acf.google_plus_url,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shift",
    attrs: {
      "src": "https://www.coastal-orthodontics.com/wp-content/uploads/2019/03/google-plus.png",
      "alt": "Google Plus"
    }
  })])]), _c('li', [_c('a', {
    attrs: {
      "href": _vm.props.acf.linkedin_url,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shift",
    attrs: {
      "src": "https://www.coastal-orthodontics.com/wp-content/uploads/2019/03/linkedin.png",
      "alt": "Linked In"
    }
  })])]), _c('li', [_c('a', {
    attrs: {
      "href": _vm.props.acf.youtube_url,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shift",
    attrs: {
      "src": "https://www.coastal-orthodontics.com/wp-content/uploads/2019/03/youtube.png",
      "alt": "YouTube"
    }
  })])])]), _c('div', {
    staticClass: "top-address"
  }, [_c('p', {
    staticClass: "phone",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.phone_number)
    }
  }), _c('router-link', {
    attrs: {
      "to": "/" + _vm.props.acf.address_url
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.address)
    }
  })])], 1)])])]), _vm._m(0), _c('div', {
    staticClass: "menu-area"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "main-menu"
  }, [_c('div', {
    staticClass: "top-close-menu"
  }), _c('ul', [_c('li', [_c('router-link', {
    staticClass: "router-link-active",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1), _c('li', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": "/meet-dr-kevin-oliveira"
    }
  }, [_vm._v("About Us")]), _c('ul', {
    staticClass: "submenu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/meet-dr-kevin-oliveira"
    }
  }, [_vm._v("Meet Dr. Kevin Oliveira")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/meet-the-team"
    }
  }, [_vm._v("Meet the Team")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/what-sets-us-apart"
    }
  }, [_vm._v("What Sets Us Apart")])], 1)])], 1), _c('li', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": "/office-visits"
    }
  }, [_vm._v("For New Patients")]), _c('ul', {
    staticClass: "submenu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/office-visits"
    }
  }, [_vm._v("Office Visits")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/financial-information"
    }
  }, [_vm._v("Financial Information")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/patient-forms"
    }
  }, [_vm._v("Patient Forms")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/orthodontic-faqs"
    }
  }, [_vm._v("Orthodontic FAQs")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/testimonials"
    }
  }, [_vm._v("Testimonials")])], 1)])], 1), _c('li', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": "/about-orthodontics"
    }
  }, [_vm._v("Wearing Braces")]), _c('ul', {
    staticClass: "submenu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/about-orthodontics"
    }
  }, [_vm._v("About Orthodontics")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/life-with-braces"
    }
  }, [_vm._v("Life with Braces")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/brushing-and-flossing"
    }
  }, [_vm._v("Brushing and Flossing")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/for-all-ages"
    }
  }, [_vm._v("For All Ages")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/early-prevention"
    }
  }, [_vm._v("Early Prevention")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/types-of-appliances"
    }
  }, [_vm._v("Types of Appliances")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/palatal-expander"
    }
  }, [_vm._v("Palatal Expander")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/orthodontic-retention"
    }
  }, [_vm._v("Orthodontic Retention")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/emergency-care"
    }
  }, [_vm._v("Emergency Care")])], 1)])], 1), _c('li', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": "/common-treatments"
    }
  }, [_vm._v("Orthodontic Treatments")]), _c('ul', {
    staticClass: "submenu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/common-treatments"
    }
  }, [_vm._v("Common Treatments")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/types-of-braces"
    }
  }, [_vm._v("Types of Braces")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/surgical-orthodontics"
    }
  }, [_vm._v("Surgical Orthodontics")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/tads"
    }
  }, [_vm._v("TADs")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/acceledent-aura"
    }
  }, [_vm._v("AcceleDent® Aura")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/dental-monitoring"
    }
  }, [_vm._v("Dental Monitoring")])], 1)])], 1), _c('li', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": "/invisalign-info"
    }
  }, [_vm._v("Invisalign®")]), _c('ul', {
    staticClass: "submenu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/invisalign-info"
    }
  }, [_vm._v("Invisalign® Info")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/invisalign-teen-info"
    }
  }, [_vm._v("Invisalign Teen® Info")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/invisalign-costs"
    }
  }, [_vm._v("Invisalign® Costs")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/invisalign-faqs"
    }
  }, [_vm._v("Invisalign® FAQs")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/invisalign-testimonials"
    }
  }, [_vm._v("Invisalign® Testimonials")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/invisalign-videos"
    }
  }, [_vm._v("Invisalign® Videos")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/invisalign-before-after"
    }
  }, [_vm._v("Invisalign® Before & After")])], 1)])], 1), _c('li', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": "/virtualsmile"
    }
  }, [_vm._v("Virtual Smile                ")])], 1), _c('li', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": "/wareham-office-location"
    }
  }, [_vm._v("Contact Us")]), _c('ul', {
    staticClass: "submenu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/wareham-office-location"
    }
  }, [_vm._v("Wareham Office Location")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/appointment-request"
    }
  }, [_vm._v("Appointment Request")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/post-appointment-survey"
    }
  }, [_vm._v("Post-Appointment Survey")])], 1)])], 1)])]), _c('div', {
    attrs: {
      "id": "mobile-menu"
    }
  }, [_vm._m(1), _c('ul', [_c('li', [_c('router-link', {
    staticClass: "router-link-active",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1), _c('li', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": "/meet-dr-kevin-oliveira"
    }
  }, [_vm._v("About Us")]), _vm._m(2), _c('ul', {
    staticClass: "submenu",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "subMenu-1"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/meet-dr-kevin-oliveira"
    }
  }, [_vm._v("Meet Dr. Kevin Oliveira")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/meet-the-team"
    }
  }, [_vm._v("Meet the Team")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/what-sets-us-apart"
    }
  }, [_vm._v("What Sets Us Apart")])], 1)])], 1), _c('li', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": "/office-visits"
    }
  }, [_vm._v("For New Patients")]), _vm._m(3), _c('ul', {
    staticClass: "submenu",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "subMenu-2"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/office-visits"
    }
  }, [_vm._v("Office Visits")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/financial-information"
    }
  }, [_vm._v("Financial Information")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/patient-forms"
    }
  }, [_vm._v("Patient Forms")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/orthodontic-faqs"
    }
  }, [_vm._v("Orthodontic FAQs")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/testimonials"
    }
  }, [_vm._v("Testimonials")])], 1)])], 1), _c('li', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": "/about-orthodontics"
    }
  }, [_vm._v("Wearing Braces")]), _vm._m(4), _c('ul', {
    staticClass: "submenu",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "subMenu-3"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/about-orthodontics"
    }
  }, [_vm._v("About Orthodontics")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/life-with-braces"
    }
  }, [_vm._v("Life with Braces")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/brushing-and-flossing"
    }
  }, [_vm._v("Brushing and Flossing")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/for-all-ages"
    }
  }, [_vm._v("For All Ages")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/early-prevention"
    }
  }, [_vm._v("Early Prevention")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/types-of-appliances"
    }
  }, [_vm._v("Types of Appliances")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/palatal-expander"
    }
  }, [_vm._v("Palatal Expander")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/orthodontic-retention"
    }
  }, [_vm._v("Orthodontic Retention")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/emergency-care"
    }
  }, [_vm._v("Emergency Care")])], 1)])], 1), _c('li', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": "/common-treatments"
    }
  }, [_vm._v("Orthodontic Treatments")]), _vm._m(5), _c('ul', {
    staticClass: "submenu",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "subMenu-4"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/common-treatments"
    }
  }, [_vm._v("Common Treatments")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/types-of-braces"
    }
  }, [_vm._v("Types of Braces")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/surgical-orthodontics"
    }
  }, [_vm._v("Surgical Orthodontics")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/tads"
    }
  }, [_vm._v("TADs")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/acceledent-aura"
    }
  }, [_vm._v("AcceleDent® Aura")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/dental-monitoring"
    }
  }, [_vm._v("Dental Monitoring")])], 1)])], 1), _c('li', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": "/invisalign-info"
    }
  }, [_vm._v("Invisalign®")]), _vm._m(6), _vm._m(7)], 1), _c('li', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": "/virtualsmile"
    }
  }, [_vm._v("Virtual Smile                ")])], 1), _c('li', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": "/wareham-office-location"
    }
  }, [_vm._v("Contact Us")]), _vm._m(8), _c('ul', {
    staticClass: "submenu",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "subMenu-6"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/wareham-office-location"
    }
  }, [_vm._v("Wareham Office Location")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/appointment-request"
    }
  }, [_vm._v("Appointment Request")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/post-appointment-survey"
    }
  }, [_vm._v("Post-Appointment Survey")])], 1)])], 1)])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "open-menu",
    attrs: {
      "onclick": "openNav()"
    }
  }, [_c('div', {
    staticClass: "i fa fa-bars"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-close-menu",
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "subMenu_open",
    attrs: {
      "id": "toggleClass-1",
      "onclick": "subMenu(1)"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "subMenu_open",
    attrs: {
      "id": "toggleClass-2",
      "onclick": "subMenu(2)"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "subMenu_open",
    attrs: {
      "id": "toggleClass-3",
      "onclick": "subMenu(3)"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "subMenu_open",
    attrs: {
      "id": "toggleClass-4",
      "onclick": "subMenu(4)"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "subMenu_open",
    attrs: {
      "id": "toggleClass-5",
      "onclick": "subMenu(5)"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "submenu",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "subMenu-5"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/invisalign-info"
    }
  }, [_vm._v("Invisalign® Info")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/invisalign-teen-info"
    }
  }, [_vm._v("Invisalign Teen® Info")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/invisalign-costs"
    }
  }, [_vm._v("Invisalign® Costs")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/invisalign-faqs"
    }
  }, [_vm._v("Invisalign® FAQs")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/invisalign-testimonials"
    }
  }, [_vm._v("Invisalign® Testimonials")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/invisalign-videos"
    }
  }, [_vm._v("Invisalign® Videos")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/invisalign-before-after"
    }
  }, [_vm._v("Invisalign® Before & After")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "subMenu_open",
    attrs: {
      "id": "toggleClass-6",
      "onclick": "subMenu(6)"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dee70fa","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/header/header.pug
// module id = 1269
// module chunks = 1